module.exports = __webpack_public_path__ + "static/media/addNew.9dc8e26e.svg";